import React from "react";
//local

const SignContractPublicPageFallback = () => {
  return (
    <div className="__text-center mt-40 __bold fz-20">
      <div>THE CONTRACT DATA HAS NOT BEEN RECEIVED.</div>
      <div>TRY TO RELOAD THE PAGE OR USE ANOTHER LINK</div>
    </div>
  );
};

export default SignContractPublicPageFallback;
